import resume from '../assets/pdf/resume.pdf'
import profile from '../assets/jpg/profile.jpg'

export const headerData = {
    name: 'Kareem Wilson',
    title: "Full-stack Developer",
    desciption:"Building digital dreams from front to back - trust me to bring your vision to life.",
    image: profile,
    resumePdf: resume
}
